<div class="card-action-menu" [flipCoachTarget]="triggerAnchor" (click)="openMenu()">
  <svg-icon
    class="evergreen"
    src="assets/icons/icon-menu.svg"
    [ngClass]="{ 'parchment': iconThemeColor === 'parchment' }"
    aria-haspopup="true"
    [svgStyle]="{ 'width.em': 0.625, 'height.em': 1.125 }"
  ></svg-icon>
</div>

<ng-template #menu>
  <div class="custom-dropdown-menu" (click)="$event.stopPropagation()">
    <div
      *ngIf="canDelete || canRemove"
      class="d-flex column justify-content-between align-items-center menu-item"
      [class.active]="activeItem === (canDelete ? 'delete' : 'remove')"
      (click)="onActionClicked(canDelete ? 'delete' : 'remove')"
    >
      <span>{{ canDelete ? 'DELETE' : 'REMOVE' }}</span>
      <svg-icon
        src="assets/icons/icon-trash.svg"
        class="icon-forestpath"
        [svgStyle]="{ 'width.em': 0.9, 'height.em': 0.9 }"
      ></svg-icon>
    </div>
    <div
      [flipCoachTarget]="rowAnchor('favourite')"
      class="d-flex column justify-content-between align-items-center menu-item"
      [class.active]="activeItem === 'favorite'"
      (click)="onActionClicked('favorite')"
    >
      <span>FAVOURITE</span>
      <svg-icon
        [src]="card.isPatientFavourite ? 'assets/icons/icon-favourite-gradient.svg' : 'assets/icons/icon-favorite-outline.svg'"
        [class.icon-forestpath]="!card.isPatientFavourite"
        [svgStyle]="{ 'width.em': 1, 'height.em': 0.9 }"
      ></svg-icon>
    </div>
    <div
      *ngIf="showSwap"
      [flipCoachTarget]="rowAnchor('swap')"
      class="d-flex column justify-content-between align-items-center menu-item"
      [class.active]="activeItem === 'swap'"
      (click)="onActionClicked('swap')"
    >
      <span>SWAP</span>
      <svg-icon
        src="assets/icons/icon-reuse.svg"
        class="icon-forestpath"
        [svgStyle]="{ 'width.em': 0.9, 'height.em': 0.9 }"
      ></svg-icon>
    </div>
    <div
      *ngIf="isEditable"
      class="d-flex column justify-content-between align-items-center menu-item"
      [class.active]="activeItem === (isCreate ? 'create' : 'edit')"
      (click)="onActionClicked(isCreate ? 'create' : 'edit')"
    >
      <span>{{ isCreate ? 'CREATE' : 'EDIT' }}</span>
      <svg-icon
        src="assets/icons/icon-edit.svg"
        class="icon-forestpath"
        [svgStyle]="{ 'width.em': 0.9, 'height.em': 0.9 }"
      ></svg-icon>
    </div>
    <div
      *ngIf="canDuplicate"
      [flipCoachTarget]="rowAnchor('duplicate')"
      class="d-flex column justify-content-between align-items-center menu-item"
      [class.active]="activeItem === 'duplicate'"
      (click)="onActionClicked('duplicate')"
    >
      <span>DUPLICATE</span>
      <svg-icon
        src="assets/icons/icon-duplicate.svg"
        class="icon-forestpath"
        [svgStyle]="{ 'width.em': 0.9, 'height.em': 0.9 }"
      ></svg-icon>
    </div>
  </div>
</ng-template>
